import React, { FC, useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Trails from "Components/Trails";
import { setShowSearchOptions, setView } from "Containers/CampusMap";

import { isMobile } from "Utils/browserProperties";
import { resetPathStops } from "Containers/Stops";
import { setTrails } from "./TrailsActions";
import { CustomTrail } from "../../../types/tour";

interface Props {
  trailsOption: boolean;
  setTrailsOption: () => void;
  showSwitcher: boolean;
}

const TrailsContainer: FC<Props> = ({
  trailsOption,
  setTrailsOption,
  showSwitcher,
}: Props) => {
  const dispatch = useDispatch();

  // This is used for the click events in the search options icons to display the proper view
  const setSearchOptionsView = useCallback(
    (view: string, showSearchOptionsMobile = true) => {
      // If it's mobile we also want to show/hide the search options based on the incoming showSearchOptionsMobile value
      if (isMobile) {
        dispatch(setShowSearchOptions(showSearchOptionsMobile));
      }
      dispatch(setView(view));
    },
    [dispatch]
  );

  // This is used in mobile only, in the Trailist component, when a user clicks on the
  // Right arrow to view the selected trails.
  // True, indicates the default view, false, indicates the Specific Trail view
  const [
    showDefaultMobileSearchOptions,
    setShowDefaultMobileSearchOptions,
  ] = useState(true);

  // This is native to the Trails component only and does not need to go into redux

  const [selectedTrails, setSelectedTrails] = useState(-1);
  const [selectedTrail, setSelectedTrail] = useState("");

  const changeTrails = (val: CustomTrail) => {
    // Store the trail name
    setSelectedTrail(val.name);

    // Add this trail to the trails array
    dispatch(setTrails(val));
  };

  useEffect(() => {
    // Only dispatch if the value is not -1.  Get the points array, associated with the index of the button that was clicked.
    return () => {
      // -1 - Reset pathStops to an empty array, in Redux, when the component is unmounted
      dispatch(resetPathStops());
    };
  }, [dispatch, selectedTrails]);

  return (
    <Trails
      setTrails={changeTrails}
      setSearchOptionsView={setSearchOptionsView}
      selectedTrails={selectedTrails}
      setSelectedTrails={setSelectedTrails}
      showDefaultMobileSearchOptions={showDefaultMobileSearchOptions}
      setShowDefaultMobileSearchOptions={setShowDefaultMobileSearchOptions}
      selectedTrail={selectedTrail}
      setSelectedTrail={setSelectedTrail}
      showTrails={trailsOption}
      setShowTrails={setTrailsOption}
      showSwitcher={showSwitcher}
    />
  );
};
export default TrailsContainer;
